import { ITermsDurationsState } from '../../types/reducers/termsDurations';

export const defaultState: ITermsDurationsState = {
  durationInDays: 1,
  durations: [],
};
